<template>
  <div class='PaymentInfo'>
    <div class="title">Detalhes do Pagamento</div>
    <div class="cont-load" v-if="load">
      <vue-spinner size="45"/>
    </div>
    <div class="cont-info" v-if="!load">
      <div
      class="info-list"
      v-for="(info, key) in data"
      :key="key"
      >
        <div class="label">{{ info.label }}</div>
        <div class="value">{{ info.value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { VueSpinner } from 'vue3-spinners'
export default {
  name: 'PaymentInfo',
  components: { VueSpinner },
  data () {
    return {
      load: false,
      data: [],
      translation: {
        authorization_code: 'Código de autorização',
        date_created: 'Data/hora',
        date_last_updated: 'Data/hora da última atualização',
        date_of_expiration: 'Data/hora da expiração',
        description: 'Descrição',
        id: 'Id',
        installments: 'Parcelamento',
        payment_method_id: 'Método de pagamento',
        payment_type_id: 'Tipo de pagamento',
        status: 'Status',
        status_detail: 'Detalhe status',
        taxes_amount: 'Taxas',
        transaction_amount: 'Valor'
      }
    }
  },
  computed: {
    ...mapGetters(['PedidoView']),
  },
  methods: {
    ...mapActions(['GetPayment'])
  },
  created () {
    this.load = true
    this.GetPayment(this.PedidoView.paymentid)
      .then(res => {
        for(let key in res) {
          if(key === 'taxes_amount' || key === 'transaction_amount') {
            this.data.push({ label: this.translation[key], value: res[key].toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) })
          }
          else {
            this.data.push({ label: this.translation[key], value: res[key] })
          }
        }
        this.load = false
      })
  }
}
</script>

<style scoped>
.PaymentInfo {
  width: 47%;
  height: 67%;
  padding: 1.5%;
  position: absolute;
  margin: auto;
  background-color: #FFFFFF;
  border-radius: 5px;
  overflow: auto;
}
.title {
  font-size: 20px;
  font-weight: bold;
}
.cont-info {
  padding: 2%;
}
.info-list {
  display: flex;
  border-bottom: thin solid #CCCCCC;
  padding: 2%;
}
.label {
  width: 50%;
  text-align: left;
}
.value {
  width: 50%;
  text-align: right;
}
.cont-load {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
